/**
 * @fileoverview Pure helpers for the ternary assessment status (AR-708).
 */

import type { TrackStatus } from '../types'

/**
 * Resolves a possibly-absent API status against the legacy boolean flag.
 * Older payloads only send the `*Completed` boolean — derive from it.
 */
export function resolveTrackStatus(status: TrackStatus | undefined, completed: boolean): TrackStatus {
  return status ?? (completed ? 'completed' : 'pending')
}

/**
 * Aggregates per-activity statuses into a single per-lesson status:
 *
 *   - every status `completed`                          → `completed`
 *   - any `in_progress`, or a mix of completed/pending  → `in_progress`
 *   - otherwise (all pending, or no activities)         → `pending`
 */
export function aggregateLessonStatus(statuses: TrackStatus[]): TrackStatus {
  if (statuses.length === 0) return 'pending'
  if (statuses.every(status => status === 'completed')) return 'completed'
  if (statuses.some(status => status !== 'pending')) return 'in_progress'
  return 'pending'
}
